import { redirectToHomeIfNoInsightsAccess } from '@/insights/router/guards';

const InsightsPage = () => import('@/insights/pages/insights.vue');

export const insightsRoutes = [
  {
    path: '/insights',
    name: 'insights',
    component: InsightsPage,
    beforeEnter: redirectToHomeIfNoInsightsAccess,
  },
];
